/*
  assets/opti-form.js
  OPTI — Jotformインラインフォームのスクリプト

  機能:
    1. JotformからのpostMessage（高さ変更通知）を受信し
       iframeの高さを動的に調整する
    2. ページロード時にstory/productパラメータをiframe srcに付与する

  読み込み方法（main-product.liquid または theme.liquid 末尾）:
    <script src="{{ 'opti-form.js' | asset_url }}" defer></script>
*/

(function () {
  'use strict';

  // ── 1. iframeの高さ自動調整（Jotform標準のpostMessage対応） ──
  window.addEventListener('message', function (event) {
    // Jotformからのメッセージのみ処理
    if (
      event.origin.indexOf('jotform.com') === -1 &&
      event.origin.indexOf('jotform.pro') === -1
    ) {
      return;
    }

    var data = event.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }

    // 高さ変更通知
    if (data && data.action === 'setHeight') {
      var iframe = document.getElementById('opti-jotform-iframe');
      if (iframe) {
        var newHeight = parseInt(data.height, 10);
        if (!isNaN(newHeight) && newHeight > 0) {
          iframe.style.height = (newHeight + 40) + 'px';
          var wrap = iframe.closest('.opti-form-iframe-wrap');
          if (wrap) {
            wrap.style.minHeight = (newHeight + 40) + 'px';
          }
        }
      }
    }

    // フォーム送信完了時のスクロール
    if (data && data.action === 'submission-completed') {
      var formSection = document.getElementById('opti-consultation-form');
      if (formSection) {
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  // ── 2. URLパラメータをiframe srcに付与（念のための補完処理） ──
  document.addEventListener('DOMContentLoaded', function () {
    var iframe = document.getElementById('opti-jotform-iframe');
    if (!iframe) return;

    // URLパラメータを取得
    var urlParams = new URLSearchParams(window.location.search);
    var story = urlParams.get('story') || 'direct';
    var currentSrc = iframe.getAttribute('src') || '';

    // すでにstoryパラメータが含まれている場合はスキップ
    if (currentSrc.indexOf('story=') === -1) {
      var separator = currentSrc.indexOf('?') !== -1 ? '&' : '?';
      iframe.setAttribute('src', currentSrc + separator + 'story=' + encodeURIComponent(story));
    }

    // ── 3. フォームへのスムーズスクロールボタン対応 ──
    // 「無料で相談する」ボタンが #opti-consultation-form にリンクしている場合
    var scrollTriggers = document.querySelectorAll('[href="#opti-consultation-form"], [data-scroll-to="consultation-form"]');
    scrollTriggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('opti-consultation-form');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });

})();
